import { get, post, patch } from './client.js';

const qs = (p) => p ? '?' + new URLSearchParams(Object.entries(p).filter(([, v]) => v != null)).toString() : '';

export const list       = (params)       => get(`/platform/plans${qs(params)}`);
export const getOne     = (planId)       => get(`/platform/plans/${planId}`);
export const create     = (body)         => post('/platform/plans', body);
export const update     = (planId, body) => patch(`/platform/plans/${planId}`, body);
export const clone      = (planId, body) => post(`/platform/plans/${planId}/clone`, body);
export const archive    = (planId)       => post(`/platform/plans/${planId}/archive`);
export const restore    = (planId)       => post(`/platform/plans/${planId}/restore`);
export const setDefault = (planId)       => post(`/platform/plans/${planId}/set-default`);
export const compare    = (aId, bId)     => get(`/platform/plans/compare?a=${aId}&b=${bId}`);
export const getHistory = (planId)       => get(`/platform/plans/${planId}/history`);
